import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateCaseParameters {
  caseId: string | null;
  updateDetailsActive: boolean;
  caseIssues: string;
  caseParties: string;
  caseContext: string;
  caseTimePeriod: string;
}

export const useUpdateCase = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const mutation = useMutation(
    async ({
      caseId,
      updateDetailsActive,
      caseIssues,
      caseParties,
      caseContext,
      caseTimePeriod,
    }: UpdateCaseParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          isUpdateSynopsis: updateDetailsActive,
          legalIssues: updateDetailsActive ? caseIssues : undefined,
          parties: updateDetailsActive ? caseParties : undefined,
          keyContext: updateDetailsActive ? caseContext : undefined,
          keyTimePeriod: updateDetailsActive ? caseTimePeriod : undefined,
        },
      });

      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/re-submit`, fetchConfig);
      if (!response.ok) {
        throw new Error('Failed to re-submit case');
      }
    },
  );

  return mutation;
};
